// src/config/firebase.config.js
// Firebase Configuration - REPLACE WITH YOUR ACTUAL VALUES

const firebaseConfig = {
  apiKey: "AIzaSyAqobY3ivsbXM0S6ytZo3LpbvwwgScC060",
  authDomain: "stories-for-memories-portal.firebaseapp.com",
  projectId: "stories-for-memories-portal",
  storageBucket: "stories-for-memories-portal.firebasestorage.app",
  messagingSenderId: "717925212427",
  appId: "1:717925212427:web:21cc6ee806234a6caec20e",
  measurementId: "G-BJP4SNHPHT"
};

export default firebaseConfig;

/* 
===================================================================
SETUP INSTRUCTIONS:
===================================================================

1. Go to https://console.firebase.google.com/
2. Click "Add project" or select existing project
3. Project name: "stories-for-memories-portal"
4. Enable Google Analytics (optional)
5. Click "Continue" and wait for project creation

6. In Firebase Console:
   - Click the Web icon (</>) to add a web app
   - App nickname: "Stories for Memories Portal"
   - Check "Also set up Firebase Hosting"
   - Click "Register app"

7. Copy the configuration object shown and replace the values above

8. Enable Authentication:
   - Go to "Authentication" → "Sign-in method"
   - Enable "Google" provider
   - Add authorized domain: portal.storiesformemories.com
   - Enable "Email/Password" provider

9. Create Firestore Database:
   - Go to "Firestore Database" → "Create database"
   - Start in "Production mode"
   - Choose location: us-central (or nearest to you)

10. Enable Storage:
    - Go to "Storage" → "Get started"
    - Start in "Production mode"

11. Install Firebase CLI:
    npm install -g firebase-tools
    firebase login
    firebase init

===================================================================
*/
